export class NvalInputModel {
  // 受付開始受注コード
  public ReceiptSOrderCode = String('');

  // 適用開始受注コード
  public StartOrderCode = String('');

  // アイテムコード
  public ItemCode = String('');

  // 注文コード
  public OrderNum = String('');

  // Ｐコード
  public PCode = String('');


  // 受付開始受注コード
  public receiptSOrderCode = String('');

  // 注文コード
  public orderNum6Digits = String('');

  // アイテムコード
  public itemCode = String('');

  // 適用開始受注コード
  public startOrderCode = String('');

}
